import moment from 'moment';
import { DEF_SEARCH_PARAM_FH } from '../components/FleetHealthV2/constants';

const defaultState = {
  searchParams: {
    ...DEF_SEARCH_PARAM_FH,
  },
  filter: {
    filterBy: 'Fleet',
    selVehIds: [],
    fromDate: moment(new Date())
      .subtract(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    toDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  },
  disableDownloadBtns: true,
  defaultVehIds: [],
};

function fleetHealthReducer(state = defaultState, action) {
  switch (action.type) {
    case 'API_FLTR_FH':
      return {
        ...state,
        searchParams: action.payload,
      };
    case 'UPD_API_FLTR_FH':
      return {
        ...state,
        defaultVehIds: action.payload.defaultVehIds,
        searchParams: {
          ...state.searchParams,
          vehicleIds: action.payload.vehicleIds,
        },
      };
    case 'FLTR_UI_STATE_FH':
      return {
        ...state,
        filter: action.payload,
      };
    case 'FH_TOGGLE_DWNLD_BTN':
      return { ...state, disableDownloadBtns: action.payload };
    default:
      return state;
  }
}

export default fleetHealthReducer;
